export default "__VITE_ASSET__4W7f_mCc__"